import Logo from "components/common/Logo";
import Account from "fetaures/account";
import NavBar from "components/header/navigation-bar/Navbar";
import { RootState } from "store/store";
import { checkIfCurrentUserHasAdminAccess } from "shared/utility/AuthUtility";
import { useSelector } from "react-redux";
import PriorityNav from "components/header/priority-navigation-bar/PriorityNav";
import NavItemOption from "interfaces/NavItemOption";
import * as routePath from "shared/constants/RoutePathConstants";

export default function Header() {
  const adminNavItems: NavItemOption[] = [
    {
      text: "User",
      route: routePath.ADMIN_USERS,
      itemId: "admin-user",
    },
    {
      text: "Product",
      route: routePath.ADMIN_PRODUCTS,
      itemId: "admin-product",
    },
    {
      text: "Contact Request",
      route: routePath.ADMIN_CONTACT_SALES,
      itemId: "admin-contact-sales",
    },
  ];

  const navItems: NavItemOption[] = [
    {
      text: "Dashboard",
      route: routePath.DASHBOARD,
      itemId: "dashboard",
    },
    {
      text: "Tokens",
      route: routePath.TOKENS,
      itemId: "tokens",
    },
    {
      text: "Get started",
      route: routePath.GET_STARTED,
      itemId: "get-started",
    },
    {
      text: "Subscription",
      route: routePath.SUBSCRIPTION,
      itemId: "subscription",
    },
    {
      text: "Invoices",
      route: routePath.INVOICES,
      itemId: "invoices",
    },
  ];

  const currentUserHasAdminAccess = useSelector((state: RootState) =>
    checkIfCurrentUserHasAdminAccess(state)
  );

  const getNavItems = () => {
    const items = navItems.slice();
    if (currentUserHasAdminAccess) {
      items.push({
        text: "Admin",
        itemId: "admin",
        children: adminNavItems,
      });
    }

    return items;
  };

  return (
    <>
      <nav className="flex flex-wrap justify-between">
        <Logo />
        <div className="mt-2 hidden xl:inline-block">
          <NavBar items={getNavItems()} />
        </div>
        <div className="mt-1">
          <Account />
        </div>
      </nav>
      <div className="w-full inline-block xl:hidden mt-5">
        <PriorityNav items={getNavItems()} />
      </div>
    </>
  );
}
